/** Mobile global MHeader — English (t('mHeader.xxx')) */
export default {
	nav: {
		home: "Home",
		square: "Media",
		tutor: "Mentors",
		serviceInstitution: "Discover",
		about: "About Us",
	},
	drawer: {
		userCenter: "Account",
		loginRegister: "Sign in / Sign up",
		downloadApp: "Download App",
		languageSwitch: "Language",
		contactCs: "Contact Us",
		mentorJoin: "Mentor Entry",
		institutionJoin: "Institution Entry",
		languageRow: "Language",
		targetEn: "EN",
		targetZh: "繁",
		ariaSwitchToEn: "Switch to English",
		ariaSwitchToZh: "Switch to Traditional Chinese",
	},
	interest: {
		title: "What interests you?",
		subtitle: "Pick topics you like and we’ll personalize your feed.",
		loading: "Loading…",
		submit: "Done ({count} selected)",
	},
	navdown: {
		title: "Download SeerQ App",
		desc: "",
		download: "Download",
		closeAria: "Dismiss download banner",
	},
};
